import { StageHubApplication, StageHubProduct } from "@/models/enums/StageHubProduct";

export interface CreateSubscriptionDto {
    subscriptionOfferId: string;
	  originatingApplication: StageHubApplication; // StageHubProduct 0 for public, 1 for backstage legacy, 2 for backstage v2, 3 for consumer
    product: StageHubProduct; // 1 for Backstage
    entityId: string;
    backstagePlan: BackstagePlan;
    billingEmail: string;
}


export enum BackstagePlan {
    Free = 0,
    Basic = 1,
    Starter = 2,
    Pro = 3
}
